import { render } from "./OpenShaft.vue?vue&type=template&id=7fe3ee6a"
import script from "./OpenShaft.vue?vue&type=script&lang=js"
export * from "./OpenShaft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__